import React from "react";
import "./sectionTwo.scss";

/* ---------------- INLINE ICONS (swap with your own SVGs if you have them) ---------------- */

const IconConnect = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 15l6-6M10 6l1.5-1.5a3.54 3.54 0 015 5L15 11M14 18l-1.5 1.5a3.54 3.54 0 01-5-5L9 13"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconUnderstand = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18h6M10 21h4M12 3a6 6 0 00-3.6 10.8c.6.45.9 1.15.9 1.9V16h5.4v-.3c0-.75.3-1.45.9-1.9A6 6 0 0012 3z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconPredict = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 20V10M10 20V4M16 20v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconOptimize = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6h16M4 12h10M4 18h13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconExecute = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 5v14l12-7L7 5z" fill="currentColor" />
  </svg>
);

const IconMeasure = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 7v5l3.2 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconMonitor = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7v5l3.2 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const IconDetect = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconDiagnose = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 2v6.5L4.5 17a2 2 0 001.8 3h11.4a2 2 0 001.8-3L15 8.5V2M9 2h6M8.5 13h7"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconDecide = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18h6M10 21h4M12 3a6 6 0 00-3.6 10.8c.6.45.9 1.15.9 1.9V16h5.4v-.3c0-.75.3-1.45.9-1.9A6 6 0 0012 3z"
      stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconAct = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 5v14l12-7L7 5z" fill="currentColor" />
  </svg>
);

/* ---------------- LEFT LIST ROW ---------------- */

const FlowRow = ({ icon: Icon, title, text }) => (
  <li className="flow-row">
    <span className="flow-icon">
      <Icon />
    </span>
    <span className="flow-title">{title}</span>
    <span className="flow-text">{text}</span>
  </li>
);

/* ---------------- RIGHT DIAGRAM NODE ---------------- */

const LoopNode = ({ icon: Icon, label, className }) => (
  <div className={`loop-node ${className}`}>
    <span className="loop-node-icon">
      <Icon />
    </span>
    <span className="loop-node-label">{label}</span>
  </div>
);

/* ---------------- SECTION ---------------- */

const SectionTwo = () => {
  return (
    <section className="epm-hero-section">
      <div className="epm-hero-container">

        {/* HEADER */}
        <div className="epm-hero-header">
          <h1 className="header-title">
            Intelligent. Integrated.<span className="no-break">Impactful.</span>
          </h1>
          <p className="epm-hero-sub">
            <span className="brand">
              <span className="brand-epm">EPM</span>
              <span className="brand-tech">Tech</span>
            </span>{" "}
            unifies your data, strategy, and execution into a single AI-native system
          </p>
        </div>

        {/* CONTENT */}
        <div className="epm-hero-content">

          {/* LEFT CARD */}
          <div className="flow-card">
            <ul className="flow-list">
              <FlowRow icon={IconConnect} title="CONNECT" text="Unified enterprise data" />
              <FlowRow icon={IconUnderstand} title="UNDERSTAND" text="KPIs • economics • relationships" />
              <FlowRow icon={IconPredict} title="PREDICT" text="Forecasts • anomalies • AskEPM" />
              <FlowRow icon={IconOptimize} title="OPTIMIZE" text="Plans • simulations • decisions" />
              <FlowRow icon={IconExecute} title="EXECUTE" text="Alerts • workflows • accountability" />
              <FlowRow icon={IconMeasure} title="MEASURE" text="Revenue • EBITDA • WC • FCF • ROCE" />
            </ul>
          </div>

          {/* RIGHT DIAGRAM */}
          <div className="loop-section">
            <h2 className="loop-title">Closed-Loop Performance Management</h2>

            <div className="loop-diagram">
              <svg
                className="loop-connectors"
                viewBox="0 0 400 400"
                preserveAspectRatio="xMidYMid meet"
              >
                <circle
                  cx="200"
                  cy="200"
                  r="160"
                  fill="none"
                  stroke="#D7DAE3"
                  strokeWidth="1.5"
                  strokeDasharray="4 520"
                  strokeDashoffset="0"
                />
                <circle
                  cx="200"
                  cy="200"
                  r="160"
                  fill="none"
                  stroke="#D7DAE3"
                  strokeWidth="1.5"
                />
              </svg>

              <div className="loop-center">
                <span>CLOSED-LOOP<br />ENGINE</span>
              </div>

              <LoopNode icon={IconMeasure} label="MEASURE" className="pos-measure node-blue" />
              <LoopNode icon={IconDetect} label="DETECT" className="pos-detect node-teal" />
              <LoopNode icon={IconDiagnose} label="DIAGNOSE" className="pos-diagnose node-lightblue" />
              <LoopNode icon={IconDecide} label="DECIDE" className="pos-decide node-orange" />
              <LoopNode icon={IconAct} label="ACT" className="pos-act node-green" />
              <LoopNode icon={IconMonitor} label="MONITOR" className="pos-monitor node-red" />
            </div>

            <p className="loop-caption">
              Insight alone does not create value. Execution does.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SectionTwo;